class BundleProductStory extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.track = this.querySelector('[data-story-track]');
    this.slides = [...this.querySelectorAll('[data-story-slide]')];
    this.dots = [...this.querySelectorAll('[data-story-dot]')];
    this.previous = this.querySelector('[data-story-prev]');
    this.next = this.querySelector('[data-story-next]');
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-story-prev],[data-story-next],[data-story-dot],[data-story-bundle]');
      if (!button) return;
      if (button.hasAttribute('data-story-bundle')) {
        const offer = document.getElementById('bp2-bundle-offer');
        if (!offer) return;
        event.preventDefault();
        offer.focus({ preventScroll: true });
        offer.scrollIntoView({ block: 'start', behavior: this.scrollBehavior });
        return;
      }
      const index = button.hasAttribute('data-story-dot') ? Number(button.dataset.storyDot) : this.index + (button === this.next ? 1 : -1);
      this.showSlide(index);
    }, { signal });
    if (!this.track) return;
    this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
    this.track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      this.showSlide(this.index + (event.key === 'ArrowRight' ? 1 : -1));
    }, { signal });
    this.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.indexOf(event.target.closest('[data-story-slide]'));
      if (index >= 0) this.showSlide(index);
    }, { signal });
    this.observer?.disconnect();
    this.observer = new ResizeObserver(() => this.updateControls());
    this.observer.observe(this.track);
    this.updateControls();
  }

  get scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  showSlide(index) {
    const slide = this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
    if (!slide || !this.track) return;
    this.track.scrollTo({ left: this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: this.scrollBehavior });
  }

  updateControls() {
    const controls = this.querySelector('[data-story-controls]');
    if (!controls || !this.slides.length) return;
    const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
    controls.hidden = !overflow;
    this.track.tabIndex = overflow ? 0 : -1;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const left = this.track.getBoundingClientRect().left;
    this.index = this.track.scrollLeft >= maxScroll - 2 && overflow ? this.slides.length - 1 : this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
    this.dots.forEach((dot, index) => dot.toggleAttribute('aria-current', index === this.index));
    this.dots[this.index]?.setAttribute('aria-current', 'true');
    this.previous.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
  }
}

if (!customElements.get('bp2-story')) customElements.define('bp2-story', BundleProductStory);
